export default () => ({
  dashboard: {},
});
